import styled from '@emotion/styled';

export const ListingMapSwitchButtonRoot = styled.div`
  display: flex;
  align-items: center;
`;

export const ListingMapSwitchButton = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: ${theme.spacing(0.5)} 0;
    margin: 0 auto ${theme.spacing(3)};
    background: ${theme.colors.neutrals.white};
    box-shadow: ${theme.shadow.level2};
    border-radius: ${theme.borderRadius.smallestSideRound};
    transition: transform 300ms;
    min-width: 140px;

    svg > path {
      fill: ${theme.colors.brand.main};
    }

    svg {
      margin-left: ${theme.spacing(1)}
    }

    button {
      flex: 1;
      white-space: nowrap;
    }
  `}
`;

export const ButtonSeparator = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: 100%;
  background: ${({ theme }) => theme.colors.neutrals.grey9};
  transform: translate3d(-50%,0,0);
`;
